import React from 'react';
export function ResultsSection() {
  return <section className="py-8 sm:py-12 md:py-16" data-id="element-607">
      <div className="max-w-6xl mx-auto px-4" data-id="element-608">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12" data-id="element-609">
          Familias Reales, Resultados Reales
        </h2>
        <div className="grid sm:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12" data-id="element-610">
          <div className="text-center p-4" data-id="element-611">
            <div className="text-4xl sm:text-5xl font-bold text-orange-600 mb-2" data-id="element-612">
              96%
            </div>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-613">
              de las familias reportan menos estrés a la hora de la cena
            </p>
          </div>
          <div className="text-center p-4" data-id="element-614">
            <div className="text-4xl sm:text-5xl font-bold text-orange-600 mb-2" data-id="element-615">
              89%
            </div>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-616">
              ahorran más de $200 al mes en comida pedida
            </p>
          </div>
          <div className="text-center p-4" data-id="element-617">
            <div className="text-4xl sm:text-5xl font-bold text-orange-600 mb-2" data-id="element-618">
              92%
            </div>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-619">
              sus hijos comen sin protestar gracias a las recetas aprobadas
            </p>
          </div>
        </div>
        <p className="text-xs sm:text-sm text-gray-600 text-center px-4" data-id="element-620">
          Basado en una encuesta a 847 familias que implementaron el Sistema
          15/15 LATAM™ durante 30 días. Los resultados pueden variar según la
          consistencia de uso.
        </p>
      </div>
    </section>;
}